const lt = {
  brand: "E2 Care",
  tagline: "Rami, susieta priežiūra.",
  nav_dashboard: "Skydelis",
  nav_residents: "Pacientai",
  nav_patients: "Pacientai",
  nav_rooms: "Kambariai",
  nav_devices: "Įrenginiai",
  nav_events: "Įvykiai",
  nav_alerts: "Įspėjimai",
  nav_users: "Komanda",
  nav_settings: "Nustatymai",
  nav_admin: "Administravimas",
  nav_signout: "Atsijungti",
  topbar_search_placeholder: "Ieškoti pacientų, kambarių, įrenginių…",
  admin_super_only: "Tik super-administratoriai gali valdyti organizacijas.",
  admin_admin_only: "Šiame puslapyje gali dirbti tik administratoriai.",
  admin_tab_orgs: "Organizacijos",
  admin_tab_users: "Vartotojai",
  admin_tab_patients: "Pacientai",
  admin_tab_rooms: "Kambariai",
  admin_tab_buildings: "Pastatai",
  admin_tab_devices: "Įrenginiai",
  admin_tab_alerts: "Įspėjimai",
  admin_tab_qa: "Testavimo įrankiai",
  admin_delete: "Ištrinti",
  admin_no_orgs_yet: "Organizacijų dar nėra.",
  admin_field_name: "Pavadinimas",
  admin_field_email: "El. paštas",
  admin_field_phone: "Telefonas",
  admin_field_password: "Slaptažodis",
  admin_field_role: "Vaidmuo",
  admin_field_type: "Tipas",
  admin_field_timezone: "Laiko juosta",
  admin_field_address: "Adresas",
  admin_field_status: "Būsena",
  admin_field_organization: "Organizacija",
  admin_password_keep: "Palikti tuščią, kad išliktų",
  admin_field_birth_date: "Gimimo data",
  admin_field_room: "Kambarys",
  admin_field_room_none: "Nepriskirta",
  admin_field_photo: "Nuotraukos URL",
  admin_field_photo_hint: "Įklijuokite viešą URL — pilnas įkėlimas v2.",
  admin_field_notes: "Priežiūros pastabos",
  admin_field_emergency_contact: "Pagrindinis avarinis kontaktas",
  admin_field_ec_name: "Vardas",
  admin_field_ec_phone: "Telefonas",
  admin_field_ec_relationship: "Ryšys",
  admin_field_mac: "MAC adresas",
  admin_field_firmware: "Programinė įranga",
  admin_field_assignment: "Priskirtas",
  admin_field_assigned_room: "Priskirtas kambarys",
  admin_field_assigned_patient: "Priskirtas pacientas",
  admin_field_assigned_hint: "Pasirinktinai. Davikliai → kambarys; apyrankės → pacientas.",
  admin_field_sensor_target: "Pritvirtinta prie",
  admin_field_sensor_target_hint: "Nurodo sistemai, ar šis jutiklis stebi duris, ar langą.",
  sensor_target_door: "Durys",
  sensor_target_window: "Langas",
  sensor_target_unset: "Nesukonfigūruota",
  admin_field_sensor_label: "Jutiklio žymė",
  admin_field_sensor_label_hint: "Patogus pavadinimas, rodomas įspėjimuose ir įvykiuose — pvz. „Priekinės durys“, „Vonios langas“.",
  admin_field_building: "Pastatas",
  admin_field_building_required: "Kambarys turi priklausyti pastatui.",
  room_openings: "Angos",
  room_no_openings: "Šiame kambaryje dar neįrengta durų ar langų jutiklių.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Paskutinis pokytis",
  admin_field_description: "Aprašymas",
  admin_field_severity: "Sunkumas",
  admin_field_patient: "Pacientas",
  admin_field_device: "Įrenginys",
  admin_field_message: "Pranešimas",
  admin_orgs_title: "Organizacijos",
  admin_orgs_sub: "Kurkite, redaguokite ir archyvuokite E2 Care nuomininkus.",
  admin_orgs_count: "organizacijos",
  admin_org_new: "Nauja organizacija",
  admin_org_new_title: "Nauja organizacija",
  admin_org_edit_title: "Redaguoti organizaciją",
  admin_org_created: "Organizacija sukurta.",
  admin_org_updated: "Organizacija atnaujinta.",
  admin_org_deleted: "Organizacija archyvuota.",
  admin_org_delete_title: "Archyvuoti organizaciją?",
  admin_org_delete_confirm: "«{name}» bus paslėpta nuo sąrašų.",
  admin_users_title: "Vartotojai",
  admin_users_sub_super: "Tvarkykite visus vartotojų paskyras visuose nuomininkuose.",
  admin_users_sub_org: "Tvarkykite {org} vartotojų paskyras.",
  admin_user_new: "Naujas vartotojas",
  admin_user_new_title: "Naujas vartotojas",
  admin_user_edit_title: "Redaguoti vartotoją",
  admin_user_created: "Vartotojas sukurtas.",
  admin_user_updated: "Vartotojas atnaujintas.",
  admin_user_deleted: "Vartotojas archyvuotas.",
  admin_user_delete_title: "Archyvuoti vartotoją?",
  admin_user_delete_confirm: "«{name}» praras prieigą.",
  admin_user_memberships: "Organizacijos narystės",
  admin_patients_title: "Pacientai",
  admin_patients_sub_super: "Tvarkykite visus pacientus visuose nuomininkuose.",
  admin_patients_sub_org: "Tvarkykite pacientus {org}.",
  admin_patient_new: "Naujas pacientas",
  admin_patient_new_title: "Naujas pacientas",
  admin_patient_edit_title: "Redaguoti pacientą",
  admin_patient_created: "Pacientas sukurtas.",
  admin_patient_updated: "Pacientas atnaujintas.",
  admin_patient_deleted: "Pacientas archyvuotas.",
  admin_patient_delete_title: "Archyvuoti pacientą?",
  admin_patient_delete_confirm: "«{name}» bus paslėptas nuo sąrašų.",
  admin_rooms_title: "Kambariai",
  admin_rooms_sub_super: "Konfigūruokite kambarius visuose nuomininkuose.",
  admin_rooms_sub_org: "Konfigūruokite kambarius {org}.",
  admin_room_new: "Naujas kambarys",
  admin_room_new_title: "Naujas kambarys",
  admin_room_edit_title: "Redaguoti kambarį",
  admin_room_created: "Kambarys sukurtas.",
  admin_room_updated: "Kambarys atnaujintas.",
  admin_room_deleted: "Kambarys archyvuotas.",
  admin_room_delete_title: "Archyvuoti kambarį?",
  admin_room_delete_confirm: "«{name}» bus paslėptas.",
  admin_devices_title: "Įrenginiai",
  admin_devices_sub_super: "Aprūpinkite Moko įrenginius visuose nuomininkuose.",
  admin_devices_sub_org: "Aprūpinkite Moko įrenginius {org}.",
  admin_device_new: "Naujas įrenginys",
  admin_device_new_title: "Naujas įrenginys",
  admin_device_edit_title: "Redaguoti įrenginį",
  admin_device_created: "Įrenginys sukurtas.",
  admin_device_updated: "Įrenginys atnaujintas.",
  admin_device_deleted: "Įrenginys archyvuotas.",
  admin_device_delete_title: "Archyvuoti įrenginį?",
  admin_device_delete_confirm: "Įrenginys {mac} bus paslėptas.",
  admin_buildings_title: "Pastatai",
  admin_buildings_sub_super: "Sugrupuokite kambarius pagal pastatą / sparną visuose nuomininkuose.",
  admin_buildings_sub_org: "Sugrupuokite kambarius pagal pastatą / sparną {org}.",
  admin_building_new: "Naujas pastatas",
  admin_building_new_title: "Naujas pastatas",
  admin_building_edit_title: "Redaguoti pastatą",
  admin_building_created: "Pastatas sukurtas.",
  admin_building_updated: "Pastatas atnaujintas.",
  admin_building_deleted: "Pastatas archyvuotas.",
  admin_building_delete_title: "Archyvuoti pastatą?",
  admin_building_delete_confirm: "«{name}» bus paslėptas.",
  admin_qa_title: "Testavimo įrankiai",
  admin_qa_sub: "Įveskite įvykius / įspėjimus testavimui be realios Moko įrangos.",
  admin_qa_event_title: "Įvesti testinį įvykį",
  admin_qa_event_sub: "Imituoja Moko webhook.",
  admin_qa_alert_title: "Įvesti testinį įspėjimą",
  admin_qa_alert_sub: "Praleidžia įvykių sluoksnį ir rašo įspėjimą tiesiogiai.",
  admin_qa_inject_event: "Įvesti įvykį",
  admin_qa_inject_alert: "Įvesti įspėjimą",
  admin_qa_event_done: "Įvykis įvestas.",
  admin_qa_alert_done: "Įspėjimas įvestas.",
  admin_qa_disclaimer: "Šie galiniai taškai turi būti išjungti gamyboje.",
  admin_alerts_title: "Įspėjimų politika",
  admin_alerts_sub: "Visos {org} įspėjimų taisyklės. Taikomos kiekvienam šio nuomininko pacientui.",
  admin_alerts_quiet_title: "Tylos valandos",
  admin_alerts_quiet_desc: "Nustatykite, kada ši organizacija veikia „nakties režimu“. Naudinga tyliau nukreipti nekritinius įspėjimus.",
  admin_alerts_quiet_hint: "Laikas interpretuojamas pagal vietinę organizacijos laiko juostą. Intervalas gali peržengti vidurnaktį (pvz. 22:00 → 06:00).",
  admin_alerts_night_start: "Naktis prasideda",
  admin_alerts_night_end: "Naktis baigiasi",
  admin_alerts_load_failed: "Įkelti įspėjimų politiką",
  admin_alerts_save_failed: "Įrašyti įspėjimų politiką",
  admin_alerts_saved: "Įspėjimų politika įrašyta.",
  admin_alerts_clear_title: "Išvalyti aktyvius įspėjimus",
  admin_alerts_clear_desc: "Vienu paspaudimu patvirtinkite visus šios organizacijos atvirus įspėjimus.",
  admin_alerts_clear_hint: "Naudinga po suplanuotų pratybų ar netinkamai sukonfigūruoto jutiklio, sukėlusio klaidingų signalų bangą. Patvirtinti įspėjimai lieka istorijoje.",
  admin_alerts_ack_all_button: "Patvirtinti visus",
  admin_alerts_ack_all_title: "Patvirtinti visus aktyvius įspėjimus?",
  admin_alerts_ack_all_confirm: "Tai pažymės kaip patvirtintą kiekvieną atvirą įspėjimą organizacijoje {org}. Šio veiksmo atšaukti negalima.",
  admin_alerts_ack_all_done: "{count} įspėjimas(-ai) patvirtinta.",
  admin_alerts_ack_all_done_generic: "Visi aktyvūs įspėjimai patvirtinti.",
  admin_alerts_ack_all_failed: "Patvirtinti visus įspėjimus",
  org_type_nursing_home: "Slaugos namai",
  org_type_assisted_living: "Globos namai",
  org_type_hospital: "Ligoninė",
  org_type_home_care: "Priežiūra namuose",
  role_admin: "Administratorius",
  role_caregiver: "Slaugytojas",
  role_family: "Šeima",
  status_active: "aktyvus",
  status_inactive: "neaktyvus",
  confirm: "Patvirtinti",
  sign_in: "Prisijungti",
  signed_in: "Prisijungta",
  sign_up: "Registruotis",
  email: "El. paštas",
  password: "Slaptažodis",
  full_name: "Pilnas vardas",
  create_account: "Sukurti paskyrą",
  no_account: "Dar neturite paskyros?",
  have_account: "Jau turite paskyrą?",
  login_welcome: "Sveiki sugrįžę",
  login_sub: "Prisijunkite, kad galėtumėte toliau stebėti savo gyventojus.",
  register_welcome: "Prisijunkite prie E2 Care",
  register_sub: "Sukurkite savo darbo vietą per mažiau nei minutę.",
  total_residents: "Pacientai",
  active_devices: "Aktyvūs įrenginiai",
  open_alerts: "Atviri įspėjimai",
  offline_gateways: "Atjungti įrenginiai",
  falls_7d: "Kritimai (7d)",
  sos_7d: "SOS (7d)",
  low_battery: "Silpna baterija",
  critical_residents: "Kritiški",
  status_ok: "Viskas gerai",
  status_warning: "Dėmesio",
  status_critical: "Kritiška",
  status_online: "Prisijungęs",
  status_offline: "Atjungtas",
  search: "Ieškoti",
  filter: "Filtruoti",
  all: "Visi",
  refresh: "Atnaujinti",
  loading: "Įkeliama…",
  no_results: "Čia dar nieko nėra.",
  view_profile: "Žiūrėti profilį",
  showing_n_of_m: "Rodoma {n} iš {m}",
  load_more: "Įkelti daugiau",
  auto_refresh: "Tiesiogiai · auto atnaujinimas",
  auto_refresh_paused: "Pristabdyta (įkelti daugiau aktyvu)",
  updated_just_now: "Atnaujinta dabar",
  updated_n_sec_ago: "Atnaujinta prieš {n}s",
  updated_n_min_ago: "Atnaujinta prieš {n}m",
  acknowledge: "Patvirtinti",
  acknowledged: "Patvirtinta",
  ack_all: "Patvirtinti visus",
  ack_all_confirm: "Patvirtinti visus {count} aktyvius įspėjimus?",
  ack_all_running: "Patvirtinama…",
  ack_all_done: "{count} įspėjimas(-ai) patvirtinta.",
  ack_all_partial: "{ok} patvirtinta · {fail} nepavyko.",
  last_seen: "Paskutinį kartą matytas",
  battery: "Baterija",
  signal: "Signalas",
  firmware: "Programinė įranga",
  room: "But. / Kamb.",
  age: "Amžius",
  emergency_contact: "Avarinis kontaktas",
  notes: "Pastabos",
  assigned_devices: "Priskirti įrenginiai",
  recent_events: "Naujausi įvykiai",
  timeline_24h: "Paskutinės 24 val.",
  delivery_status: "Pristatymo būsena",
  acknowledged_by: "Patvirtino",
  dashboard_title: "Apžvalga",
  dashboard_sub: "Greita visko, kas vyksta jūsų prižiūrimuose namuose, apžvalga.",
  residents_title: "Pacientai",
  residents_sub: "Žmonės, kuriuos šiuo metu stebite.",
  devices_title: "Įrenginiai",
  devices_sub: "Davikliai ir apyrankės.",
  devices_sub_admin: "Šliuzai, davikliai ir apyrankės.",
  events_title: "Tiesioginiai įvykiai",
  events_sub: "Chronologinis srautas iš kiekvieno prijungto įrenginio.",
  alerts_title: "Įspėjimai",
  alerts_sub: "Pranešimai, perduoti šeimai ir slaugytojams.",
  settings_title: "Nustatymai",
  settings_sub: "Jūsų nuostatos ir pranešimų taisyklės.",
  users_title: "Komanda",
  users_sub: "Slaugytojai, šeima ir administratoriai su prieiga.",
  falls_chart_title: "Kritimai ir SOS — paskutinės 7 dienos",
  recent_alerts_title: "Naujausi kritiški įspėjimai",
  no_alerts: "Nėra atvirų įspėjimų. Visi saugūs.",
  event_fall: "Aptiktas kritimas",
  event_sos: "Paspaustas SOS mygtukas",
  event_door_open: "Atidarytos durys",
  event_door_close: "Uždarytos durys",
  event_inactivity: "Ilgalaikis neveiklumas",
  event_low_battery: "Silpna baterija",
  event_offline: "Įrenginys atjungtas",
  event_online: "Įrenginys vėl prisijungęs",
  event_heartbeat: "Širdies plakimas",
  event_button_press: "Paspaustas mygtukas",
  device_gateway: "Bluetooth šliuzas",
  device_door_sensor: "Durų daviklis",
  device_bracelet: "Apyrankė",
  device_unknown: "Nežinomas įrenginys",
  language: "Kalba",
  notifications: "Pranešimai",
  quiet_hours: "Tylos valandos",
  escalation: "Eskalavimo politika",
  just_now: "ką tik",
  rel_prefix: "prieš",
  min_ago: "min",
  h_ago: "val.",
  d_ago: "d.",
  demo_hint: "Demo paskyra: admin@e2care.lv / Care2024!",
  open_menu: "Atidaryti meniu",
  close_menu: "Uždaryti meniu",
  care_team: "Priežiūros komanda",
  family_members: "Šeima",
  no_caregivers: "Slaugytojų dar nepriskirta.",
  no_family: "Šeimos narių dar nesusieta.",
  add_caregiver: "Pridėti slaugytoją",
  add_family: "Pridėti šeimos narį",
  select_user: "Pasirinkite vartotoją…",
  cancel: "Atšaukti",
  add: "Pridėti",
  remove: "Pašalinti",
  save: "Išsaugoti",
  relationship: "Giminystė",
  relationship_son: "Sūnus",
  relationship_daughter: "Dukra",
  relationship_spouse: "Sutuoktinis",
  relationship_other: "Kita",
  notify_via: "Pranešti per",
  call_contact: "Skambinti",
  view_resident: "Atidaryti profilį",
  address: "Adresas",
  admin_only_section: "Administratoriaus įrankiai",
  rooms_title: "Kambariai",
  rooms_sub: "Kiekvienas prižiūrimas kambarys — pacientai, įrenginiai ir dabartinė būsena.",
  room_name: "Kambarys",
  room_type: "Tipas",
  room_type_private_room: "Privatus kambarys",
  room_type_shared_room: "Bendras kambarys",
  room_type_apartment: "Butas",
  room_type_corridor: "Koridorius",
  room_type_common_area: "Bendra erdvė",
  room_floor: "Aukštas",
  room_state: "Dabartinė būsena",
  door: "Durys",
  window: "Langas",
  door_open_state: "Atidarytos",
  door_closed_state: "Uždarytos",
  door_unknown_state: "Nežinoma",
  room_no_devices: "Šiame kambaryje dar nėra įrenginių.",
  room_no_patients: "Šiam kambariui dar nepriskirta pacientų.",
  room_patients: "Pacientai kambaryje",
  room_devices: "Įrenginiai kambaryje",
  room_activity: "Veiklos chronologija",
  rooms_filter_all_types: "Visi tipai",
  widget_active_alerts: "Aktyvūs įspėjimai",
  widget_active_alerts_sub: "Kritiški, neišspręsti ir patvirtinti",
  widget_patients_status: "Pacientų būsena",
  widget_devices_health: "Įrenginių būklė",
  widget_room_activity: "Kambarių veikla",
  widget_recent_events: "Tiesioginių įvykių srautas",
  widget_connectivity: "Ryšys",
  metric_critical: "Kritiška",
  metric_unresolved: "Neišspręsta",
  metric_acknowledged_count: "Patvirtinti",
  metric_total: "Iš viso",
  metric_active: "Aktyvūs",
  metric_online: "Prisijungęs",
  metric_offline: "Atjungtas",
  metric_ota_pending: "OTA laukia",
  metric_battery_warn: "Silpna baterija",
  metric_doors_open: "Atidarytos durys",
  metric_windows_open: "Atidaryti langai",
  metric_signal_avg: "Vid. signalas",
  metric_last_comm: "Pask. ryšys",
  metric_packets: "Paketų / val.",
  view_all: "Žiūrėti visus",
  status_new: "Naujas",
  status_acknowledged: "Patvirtintas",
  status_resolved: "Išspręstas",
  status_resolved_local: "Išspręsta (vietinė)",
  resolve: "Išspręsti",
  add_note: "Pridėti pastabą",
  save_note: "Išsaugoti pastabą",
  resolve_local_badge: "tik šiame įrenginyje",
  resolve_local_hint: "Pažymi įspėjimą kaip išspręstą tik jūsų naršyklėje. Serveris ir kiti komandos nariai vis dar mato jį kaip atvirą.",
  note_placeholder: "Pridėkite konteksto komandai…",
  notes_count: "{n} pastabų",
  device_detail: "Įrenginio detalė",
  device_diagnostics: "Diagnostika",
  device_firmware_history: "Programinės įrangos istorija",
  device_ota_config: "OTA konfigūracija",
  device_ota_status: "OTA būsena",
  device_signal: "Signalo kokybė",
  device_mac: "MAC adresas",
  device_serial: "Serijos numeris",
  fall_sensitivity: "Kritimo jautrumas",
  transmission_interval: "Perdavimo intervalas",
  low_battery_threshold: "Žemos baterijos slenkstis",
  ota_idle: "Neveiklus",
  ota_pending: "Laukia",
  ota_deploying: "Diegiamas",
  ota_failed: "Nepavyko",
  events_filter_severity: "Sunkumas",
  events_filter_room: "Kambarys",
  events_filter_patient: "Pacientas",
  events_filter_device: "Įrenginys",
  severity_info: "Info",
  severity_warning: "Įspėjimas",
  severity_critical: "Kritiška",
  telegram_title: "Telegram įspėjimai",
  telegram_desc: "Gaukite Telegram įspėjimus apie jums priskirtus gyventojus.",
  telegram_connect: "Prijungti Telegram",
  telegram_connected: "Telegram prijungtas",
  telegram_connected_as: "Prijungta prie Telegram kaip {name}",
  telegram_connect_success: "Telegram sėkmingai prijungtas",
  telegram_connect_error: "Nepavyko prijungti Telegram. Bandykite dar kartą.",
  telegram_missing_bot: "Telegram botas nesukonfigūruotas. Nustatykite REACT_APP_TELEGRAM_BOT env faile.",
  telegram_disconnect: "Atjungti",
  telegram_disconnect_success: "Telegram atjungtas.",
  telegram_disconnect_error: "Nepavyko atjungti Telegram. Bandykite dar kartą.",
  telegram_already_linked: "Ši Telegram paskyra jau susieta su kitu e2-care naudotoju.",
  telegram_switch_q: "Naudoti kitą Telegram paskyrą?",
  telegram_switch_intro: "Telegram įsimena, kuri paskyra prisijungusi visose svetainėse. Norėdami naudoti kitą:",
  telegram_switch_step1: "Atidarykite Telegram Web ir atsijunkite nuo dabartinės paskyros.",
  telegram_switch_step2: "Grįžkite čia ir iš naujo įkelkite žemiau esantį mygtuką, tada prisijunkite su kita paskyra.",
  telegram_open_web: "Atidaryti Telegram Web",
  telegram_reload_widget: "Atsijungiau — įkelti mygtuką iš naujo",
  lang_autodetected_toast: "Aptikta jūsų kalba: {language}. Galite ją pakeisti Nustatymuose.",
  admin_view_active: "Aktyvūs",
  admin_view_archived: "Archyvuoti",
  admin_restore: "Atkurti",
  admin_restored: "Atkurta.",
  admin_hard_delete: "Ištrinti visam laikui",
  admin_hard_delete_title: "Ištrinti visam laikui?",
  admin_hard_delete_confirm: "«{name}» bus visam laikui pašalintas iš duomenų bazės. Šio veiksmo negalima atšaukti.",
  admin_hard_deleted: "Visam laikui ištrintas.",
  admin_no_archived: "Nėra archyvuotų elementų.",
  language_desc: "Naudojama programos sąsajai ir jūsų Telegram + push pranešimams.",
  language_saved: "Kalba atnaujinta.",
  language_error: "Nepavyko atnaujinti kalbos. Bandykite dar kartą.",
  admin_field_language: "Kalba",
  edit: "Redaguoti",
  generic_error: "Kažkas nutiko. Bandykite dar kartą.",
  caregiver_added: "Slaugytojas pridėtas.",
  caregiver_removed: "Slaugytojas pašalintas.",
  family_added: "Šeimos narys pridėtas.",
  family_removed: "Šeimos narys pašalintas.",
  menu: "Meniu",
  dl_companion_app: "Palydovinė programa",
  dl_hero_title: "E2 Care, skirta Android",
  dl_hero_sub: "Įdiekite palydovinę programą į Moko įrenginiu aprūpintą telefoną, kad perduotumėte įspėjimus, konfigūruotumėte įrenginius ir palaikytumėte ryšį su savo priežiūros komanda — net kai skydelis uždarytas.",
  dl_android_apk: "Android APK",
  dl_version_loading: "įkeliama versija…",
  dl_released: "Išleista {date}",
  dl_download_apk: "Atsisiųsti APK",
  dl_unavailable: "Nepasiekiama",
  dl_preparing: "Ruošiama…",
  dl_manifest_error: "Nepavyko įkelti manifesto. Pabandykite atnaujinti — jei problema išlieka, kūrimo serveris gali būti iš naujo diegiamas.",
  dl_whats_new: "Kas naujo",
  dl_installing_title: "Diegimas telefone",
  dl_step1: "Palieskite „Atsisiųsti APK“ viršuje. Jūsų naršyklė gali įspėti, kad APK failai gali pakenkti įrenginiui — šis įspėjimas įprastas bet kuriam ne iš Play Store atsisiųstam diegimo failui.",
  dl_step2: "Atidarykite atsisiųstą failą. Android pirmą kartą paprašys leisti diegti iš šios naršyklės — įjunkite leidimą ir grįžkite.",
  dl_step3: "Palieskite „Įdiegti“, tada „Atidaryti“, kai baigsis.",
  dl_step4: "Prisijunkite naudodami savo E2 Care prisijungimo duomenis.",
  dl_iphone_note: "iPhone versija bus vėliau. Kol kas naudokite žiniatinklio skydelį.",
  dl_back_to_dashboard: "Grįžti į skydelį",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Pakeitus organizaciją, dabartinis kambario ir paciento priskyrimas išvalomas.",
  admin_view_full: "Visas sąrašas",
  device_filter_assignment: "Priskyrimas",
  device_filter_patient: "Priskirta pacientui",
  device_filter_room: "Priskirta kambariui",
  device_filter_unassigned: "Nepriskirta",
  admin_all_orgs: "Visos organizacijos",
  pagination_prev: "Ankstesnis",
  pagination_next: "Kitas",
  pagination_per_page: "Puslapyje",
  pagination_page_of: "Puslapis {page} iš {pages}",
  pagination_total: "Iš viso {total}",
  event_charging: "Įkrovimas pradėtas",
  event_sos_cancel: "SOS atšauktas",
  event_call: "SOS skambutis",
  device_personal_alarm: "Asmeninis pavojaus signalas",
  device_charging: "Kraunama",
  device_location: "Vieta",
  device_current_location: "Dabartinė vieta",
  device_no_location: "Vieta dar nepranešta.",
  device_location_source: "Šaltinis",
  device_location_updated: "Atnaujinta",
  device_track_1h: "1 val.",
  device_track_24h: "24 val.",
  device_track_7d: "7 d.",
  device_track_last: "Paskutinė vieta",
  device_located: "Rasta",
  map_sos: "SOS signalas",
  map_fall: "Aptiktas kritimas",
  map_current: "Dabartinė vieta",
  alert_timeline: "Įspėjimo laiko juosta",
  alert_trigger: "Priežastis",
  alert_calls: "Skambučiai",
  alert_view_timeline: "Peržiūrėti laiko juostą",
  alert_no_deliveries: "Pranešimų dar neišsiųsta.",
  alert_cancelled_on_device: "SOS buvo atšauktas įrenginyje — įspėjimas lieka atviras, kol slaugytojas jį išspręs.",
  call_answered: "Atsakyta",
  call_missed: "Praleista",
  reopen: "Atidaryti iš naujo",
  reopened: "Įspėjimas atidarytas iš naujo",
  live: "Tiesiogiai",
  nav_home: "Pradžia",
  family_home_kicker: "Šeimos rodinys",
  family_home_title: "Jūsų artimieji",
  family_greeting: "Sveiki",
  family_home_sub: "Ramus apžvalga, kaip laikosi kiekvienas.",
  family_status_ok: "jaučiasi gerai",
  family_status_attention: "reikia dėmesio",
  family_all_calm: "Šiuo metu viskas ramu.",
  family_attention_sub: "Pažiūrėkime, kaip jam sekasi — išsamiau žemiau.",
  family_last_seen: "paskutinį kartą matytas",
  family_latest_alert: "Paskutinis įspėjimas",
  family_no_alerts: "Naujų įspėjimų nėra — viskas gerai.",
  family_view_details: "Peržiūrėti išsamiau",
  family_no_device: "Asmeninis signalas dar nesusietas.",
  status_never_reported: "Niekada nepranešė",
  mv_title: "Judėjimas",
  mv_sub: "Iš {n} judesio jutiklio(-ių) · 5 minučių langai",
  mvo_title: "Judėjimas iš pirmo žvilgsnio",
  mvs_moving: "{name} juda",
  mvs_moving_sub: "Judėjo {when}",
  mvs_rest: "{name} ilsisi",
  mvs_rest_sub: "Paskutinį kartą judėjo {when}",
  mvs_rest_sub_none: "Per pastarąsias 30 dienų judėjimo nebuvo",
  mvs_quiet: "{name} ramiai būna ilgiau nei įprastai",
  mvs_quiet_sub: "Judėjimo nėra jau {dur}. Gal verta paskambinti.",
  mvs_short_quiet: "Ilgai ramu",
  mvs_room_moving: "Kažkas juda patalpoje {name}",
  mvs_room_rest: "{name} ramu",
  mvs_room_quiet: "Patalpoje {name} judėjimo nėra ilgiau nei įprastai",
  mvs_sensor: "Judesio jutiklis nesiunčia duomenų",
  mvs_sensor_sub: "Tai susiję su jutikliu, ne su {name}. Paskutinis signalas {when}.",
  mvs_nodata: "Judėjimo duomenų dar nėra",
  mvs_nodata_sub: "Judesio jutiklis dar nieko neatsiuntė.",
  mvd_title: "Paskutinės 24 valandos",
  mvd_moving: "Juda",
  mvd_resting: "Ilsisi",
  mvd_nosignal: "Nėra signalo",
  mvd_night: "Naktis",
  mvd_now: "Dabar",
  mvn_title: "Paskutinės 7 naktys",
  mvn_last_night: "Praėjusią naktį",
  mvn_last_short: "Vakar",
  mvn_calm: "Rami",
  mvn_restless: "Nerami",
  mvn_still: "Labai rami",
  mvn_silent: "Jutiklis tylėjo",
  mvn_nodata: "Nėra duomenų",
  mvn_s_calm_none: "Rami naktis, judėjimo nebuvo nuo {from} iki {to}.",
  mvn_s_calm_once: "Rami naktis, kėlėsi kartą apie {at}.",
  mvn_s_calm_many: "Rami naktis, kėlėsi {n} kartus, pirmą kartą apie {first}, paskutinį apie {last}.",
  mvn_s_restless: "Nerami naktis, kėlėsi {n} kartus nuo {first} iki {last}.",
  mvn_s_still: "Labai rami naktis, mažiau judėjimo nei įprastai. Ilgiausias poilsis {dur}.",
  mvn_s_still_moved: "Labai rami naktis, judėjo tik apie {at}. Ilgiausias poilsis {dur}.",
  mvn_s_silent: "Jutiklis beveik tylėjo, todėl negalime pasakyti, kaip praėjo naktis.",
  mvn_s_nodata: "Šiai nakčiai judėjimo duomenų nėra.",
  mv_state_moving: "Juda",
  mv_state_still: "Ilsisi",
  mv_state_inactive: "Neaktyvus",
  mv_state_silent: "Jutiklis nesiunčia duomenų",
  mv_state_never: "Niekada nepranešė",
  mv_state_nodata: "Duomenų dar nėra",
  mv_state_no_sensor: "Nėra judesio jutiklio",
  mv_last_movement: "Paskutinis judesys",
  mv_last_sample: "Paskutinis jutiklio signalas",
  mv_none_in_retention: "Nėra per pastarąsias 30 dienų",
  mv_silent_hint: "Jokių duomenų ilgiau nei {min} min — patikrinkite jutiklį arba jo šliuzą. Tai įrenginio gedimas, o ne nejudrumas.",
  mv_inactive_hint: "Judėjimo nėra ilgiau nei {min} min, nors jutiklis vis dar siunčia duomenis.",
  mv_history: "Judėjimo istorija",
  mv_history_empty: "Šiame laikotarpyje judėjimo duomenų dar nėra.",
  mv_not_reporting: "Nesiunčia duomenų",
  mv_no_movement: "Judėjimo nėra",
  mv_detections: "judesio aptikimai",
  mv_legend_motion: "Judesio aptikimai",
  mv_legend_gap: "Nesiunčia duomenų",
  mv_retention_note: "Istorija saugoma 30 dienų",
  mv_strip_title: "Judėjimas realiu laiku",
  mv_strip_sub: "{n} judesio jutiklis(-iai)",
  mv_unassigned: "Nepriskirtas jutiklis",
  admin_alerts_timezone: "Organizacijos laiko juosta",
  admin_alerts_timezone_invalid: "Pasirinkite galiojančią IANA laiko juostą.",
  admin_alerts_night_wrap_hint: "Nakties valandos trunka nuo {start} iki {end} kitą rytą ({tz}), t. y. po {start} arba prieš {end}.",
  admin_alerts_night_same_day_hint: "Nakties valandos trunka nuo {start} iki {end} tą pačią dieną ({tz}).",
  admin_alerts_night_equal: "Pradžia ir pabaiga negali sutapti.",
  admin_alerts_inactivity_label: "Neaktyvumo slenkstis",
  admin_alerts_inactivity_question: "Ar šis žmogus judėjo? Minutės be judėjimo, kol tai tampa pavojaus priežastimi.",
  admin_alerts_silence_label: "Įrenginio tylos slenkstis",
  admin_alerts_silence_question: "Ar šis jutiklis vis dar ryšyje? Minutės be jokio signalo, kol tai laikoma įrenginio gedimu, o ne neaktyviu gyventoju.",
  admin_alerts_minutes: "minutės",
  admin_alerts_threshold_invalid: "Įveskite sveikąjį skaičių, didesnį už 0.",
  admin_alerts_thresholds_provisional: "Pradinės reikšmės (180 / 30 min) dar nesureguliuotos — pritaikykite jas savo gyventojams.",
  admin_tab_gateways: "Šliuzai",
  gw_title: "Šliuzai",
  gw_status_deactivated: "Išjungtas",
  gw_scope_pending: "Jūsų organizacijos šliuzai atsiras čia, kai bus įdiegtas sistemos atnaujinimas.",
  gw_none_for_org: "Šiai organizacijai dar nepriskirtas joks šliuzas.",
  gw_col_room: "Kambarys",
  gw_unassigned: "Nepriskirtas",
  gw_never: "Niekada",
  gw_edit_title: "Redaguoti šliuzą",
  gw_new_title: "Naujas šliuzas",
  gw_super_field: "Tai gali keisti tik superadministratorius",
  gw_mac_invalid: "Įveskite 12 šešioliktainių simbolių, pvz. AA:BB:CC:DD:EE:FF",
  gw_hw_type: "Įrangos tipas",
  gw_notes: "Pastabos",
  gw_manage_sub: "BLE šakotuvai, perduodantys jutiklių duomenis: būsena, organizacija ir kambarys. Tylus šliuzas nutildo visus už jo esančius jutiklius.",
  gw_filter_all: "Visos organizacijos",
  gw_new: "Naujas šliuzas",
  gw_col_assignment: "Organizacija · Kambarys",
  gw_backend_pending: "Tam reikia sistemos atnaujinimo, kuris dar neįdiegtas.",
  gw_save_failed: "Išsaugoti šliuzą",
  gw_created: "Šliuzas sukurtas",
  gw_saved: "Šliuzas išsaugotas",
  gw_reactivated: "Šliuzas vėl įjungtas",
  gw_deactivated: "Šliuzas išjungtas",
  gw_reactivate: "Įjungti vėl",
  gw_deactivate: "Išjungti",
  gw_reactivate_title: "Vėl įjungti {name}?",
  gw_deactivate_title: "Išjungti {name}?",
  gw_reactivate_desc: "Jis vėl bus skaičiuojamas būsenoje ir įspėjimuose.",
  gw_deactivate_desc: "Jis nebeskaičiuojamas būsenoje ir įspėjimuose. Istorija išsaugoma, galite bet kada vėl įjungti.",
  gw_heard_title: "Girdimi įrenginiai",
  gw_heard_sub: "Jutikliai, kuriuos šis šliuzas perdavė per pastarąsias 24 valandas.",
  gw_heard_none: "Per pastarąsias 24 valandas įrenginių nėra.",
  gw_heard_unknown: "Nežinomi įrenginiai",
  gw_msgs_short: "praneš.",
  gw_avg: "vid.",
  gw_samples_short: "mėginiai",
  gw_not_found: "Šliuzas nerastas arba jums nematomas.",
  gw_one: "Šliuzas",
  gw_manage_link: "Tvarkyti administravime",
  gw_rssi_range: "Signalo intervalas",
  gw_longest_gap: "Ilgiausia pertrauka",
  gw_config_push: "Paskutinis konfig. siuntimas",
  gw_sub: "BLE šakotuvai, perduodantys jutiklių duomenis. Tik skaitymui — tylintis šliuzas priverčia tylėti visus už jo esančius jutiklius.",
  gw_super_only: "Šliuzų būsena prieinama tik superadministratoriams.",
  gw_load_failed: "Šliuzų įkėlimas",
  gw_status_reporting: "Praneša",
  gw_status_silent: "Tyli",
  gw_status_never_seen: "Niekada nematytas",
  gw_returned: "Grįžo po {h} h pertraukos (baigėsi {at})",
  gw_count_reporting: "{n} praneša",
  gw_count_silent: "{n} tyli",
  gw_count_never: "{n} niekada nematyti",
  gw_count_deactivated: "išjungta: {n}",
  gw_window: "Pasenęs po {h} h be pranešimo",
  gw_col_name: "Šliuzas",
  gw_col_status: "Būsena",
  gw_col_msgs: "Pranešimai 24 h",
  gw_col_discard: "Atmesta",
  gw_last_message: "Paskutinis pranešimas",
  gw_devices_seen: "Matyti įrenginiai",
  gw_hours_active: "Aktyvios valandos",
  gw_unregistered_title: "Praneša be registracijos",
  gw_unregistered_desc: "Šie identifikatoriai matomi šliuzų veikloje, bet neturi įrašo (pvz., įrenginys, pranešantis su IMEI). Abiejų šaltinių sumos pagrįstai skiriasi.",
  nav_reports: "Ataskaitos",
  rep_night_title: "Nakties suvestinė",
  rep_night_desc: "Rytinė kiekvieno gyventojo judėjimo suvestinė organizacijos nakties valandomis ir jutiklių tylos laikotarpiai.",
  rep_last_night: "Praėjusi naktis",
  rep_nights_ago: "Prieš {n} naktis",
  rep_policy_fallback: "numatytosios nakties valandos (politika nepasiekiama)",
  rep_movement: "Judėjimas",
  rep_windows: "{n} aktyvūs 5 min langai",
  rep_no_movement: "Judėjimo nėra",
  rep_first_movement: "Pirmas judesys",
  rep_longest_still: "Ilgiausias nejudrumo laikotarpis",
  rep_silences: "Jutiklio tyla",
  rep_none: "Nėra",
  rep_coverage: "{pct}% gauta",
  rep_night_note: "Laikas nurodytas organizacijos laiko juostoje. Nejudrumas skaičiuojamas tik kai jutiklis siunčia duomenis; tylos laikotarpiai, siekiantys tylos slenkstį, išvardyti atskirai.",
  dh_reporting_title: "Pranešimų būklė",
  dh_never_reported_desc: "Užregistruotas, bet niekada nepranešė. Tai nebaigtas įrengimas, o ne neprisijungęs įrenginys.",
  dh_interval_still: "Išmatuotas intervalas (ramybėje)",
  dh_interval_moving: "Išmatuotas intervalas (judant)",
  dh_interval_samples: "Matavimo imtys",
  dh_interval_unmeasured: "Išmatuoto intervalo dar nėra — taikomas organizacijos tylos slenkstis.",
  dh_interval_note: "Intervalai matuojami pagal gautus pranešimus, o ne pagal nustatytą reikšmę.",
  rep_dur_h_min: "{h} val. {m} min.",
  rep_dur_min: "{m} min.",
  rep_shared_room: "Bendras kambarys — gali apimti kitų judėjimą",
  rep_no_data_night: "Šiai nakčiai duomenų nėra — jutiklis nesiuntė duomenų (arba dar nebuvo įrengtas).",
  nav_buildings: "Pastatai",
  imei_label: "IMEI",
  imei_hint: "15 skaitmenų, atspausdintų įrenginio galinėje pusėje",
  imei_length: "IMEI turi 15 skaitmenų",
  imei_invalid: "Šis IMEI negalioja. Patikrinkite skaitmenis",
  imei_resident_note: "Pavojaus mygtukas lydi gyventoją, todėl jis nepriskiriamas kambariui.",
  imei_online_hint: "Įrenginys tampa prisijungęs po pirmo gyvybės signalo, maždaug per 5 minutes po įjungimo.",
  forgot_link: "Pamiršote slaptažodį? Spustelėkite čia",
  forgot_title: "Atkurti slaptažodį",
  forgot_sub: "Įveskite el. paštą ir atsiųsime nuorodą slaptažodžiui atkurti.",
  forgot_submit: "Siųsti nuorodą",
  forgot_sent: "Jei šiam el. paštui yra paskyra, išsiuntėme nuorodą slaptažodžiui atkurti. Patikrinkite pašto dėžutę.",
  forgot_back: "← Atgal į prisijungimą",
  reset_title: "Nustatyti naują slaptažodį",
  reset_sub: "Pasirinkite naują paskyros slaptažodį.",
  reset_new_password: "Naujas slaptažodis",
  reset_confirm_password: "Patvirtinkite slaptažodį",
  reset_hint: "Bent 8 simboliai.",
  reset_submit: "Atnaujinti slaptažodį",
  reset_success: "Slaptažodis atnaujintas. Nukreipiama į prisijungimą…",
  reset_too_short: "Slaptažodį turi sudaryti bent 8 simboliai.",
  reset_mismatch: "Slaptažodžiai nesutampa.",
  reset_no_token: "Ši nuoroda negalioja arba jos nėra. Paprašykite naujos prisijungimo puslapyje.",
  reset_failed: "Ši nuoroda negalioja arba baigė galioti. Paprašykite naujos.",
  admin_tab_device_types: "Įrenginių tipai",
  admin_dt_title: "Įrenginių tipai",
  admin_dt_sub: "Įrenginių modelių katalogas. Pervadinkite tipo rodomą pavadinimą — vidinis raktas, IoT susiejimas ir sinchronizavimas nesikeičia.",
  admin_dt_col_label: "Rodomas pavadinimas",
  admin_dt_col_key: "Vidinis raktas",
  admin_dt_col_category: "Kategorija",
  admin_dt_col_wearable: "Nešiojamas",
  admin_dt_col_ble_sync: "BLE sinchronizavimas",
  admin_dt_col_ble_type_id: "BLE tipo ID",
  admin_dt_wearable_yes: "Nešioja gyventojas",
  admin_dt_wearable_no: "Stacionarus",
  admin_dt_ble_sync_on: "Būtinas",
  admin_dt_ble_sync_off: "Išjungtas",
  admin_dt_edit_label: "Redaguoti pavadinimą",
  admin_dt_edit_title: "Pervadinti",
  admin_dt_edit_desc: "Keičiasi tik žmogui skaitomas pavadinimas. Įrenginiai, filtrai ir integracijos toliau naudoja vidinį raktą „{key}“.",
  admin_dt_label_saved: "Pavadinimas atnaujintas.",
  admin_dt_label_required: "Pavadinimas negali būti tuščias.",
  admin_dt_load_failed: "Įrenginių tipų įkėlimas",
  admin_dt_save_failed: "Pavadinimo atnaujinimas",
  admin_dt_readonly_hint: "Tik superadministratoriai gali pervadinti.",
  sensor_climate: "Klimatas",
  sensor_temperature: "Temperatūra",
  sensor_humidity: "Drėgmė",
  sensor_last_reading: "Paskutinis rodmuo",
  sensor_history_title: "Temperatūra ir drėgmė (48 val.)",
  sensor_history_empty_title: "Rodmenų dar nėra",
  sensor_history_empty_sub: "Priskirkite šiam kambariui H4 Pro jutiklį, kad matytumėte klimato istoriją.",
  admin_thresholds_title: "Jutiklių slenksčiai",
  admin_thresholds_desc: "Temperatūros ir drėgmės pavojaus ribos šios organizacijos H4 Pro jutikliams.",
  admin_thresholds_temp_min: "Min. temperatūra",
  admin_thresholds_temp_max: "Maks. temperatūra",
  admin_thresholds_hum_min: "Min. drėgmė",
  admin_thresholds_hum_max: "Maks. drėgmė",
  admin_thresholds_temp_invalid: "Min. temperatūra turi būti žemesnė už maks.",
  admin_thresholds_hum_invalid: "Min. drėgmė turi būti mažesnė už maks.",
  admin_thresholds_hint: "Visi keturi neprivalomi — palikite lauką tuščią, jei šiai ribai pavojaus nereikia.",
  admin_thresholds_cooldown: "Pavojų pertrauka",
  admin_thresholds_cooldown_placeholder: "Numatytoji: 30 min.",
  admin_thresholds_cooldown_help: "Minutės tarp pasikartojančių jutiklio pavojų. Palikite tuščią sistemos numatytajai vertei (30 min.).",
  admin_thresholds_cooldown_invalid: "Pertrauka turi būti sveikasis skaičius, ne mažiau 1 minutės.",
  admin_thresholds_saved: "Slenksčiai išsaugoti.",
  admin_thresholds_load_failed: "Slenksčių įkėlimas",
  admin_thresholds_save_failed: "Slenksčių išsaugojimas",
  room_activity_view_all: "Rodyti visus įvykius",
  role_super_admin: "Superadministratorius",
  assign_device: "Priskirti įrenginį",
  select_device: "Pasirinkite įrenginį…",
  admin_patient_no_devices_assigned: "Nepriskirta jokių įrenginių.",
  admin_patient_no_wearables: "Šioje organizacijoje nėra laisvų nešiojamų įrenginių.",
  admin_patient_device_reassign: "perskirti",
  recent_critical_alerts_title: "Naujausi kritiniai pavojai",
  rooms_building_clear: "Išvalyti filtrą",
  buildings_title: "Pastatai",
  buildings_sub: "Kiekvienas jūsų prižiūrimas pastatas su kambariais, gyventojais ir įrenginiais.",
  buildings_view_rooms: "Rodyti kambarius",
  wt_title: "Savaitės tendencija",
  wt_desc: "Septynios naktys greta kiekvienam gyventojui — ar bendram kambariui — neramioms ar neįprastai nejudrioms naktims pastebėti.",
  wt_baseline_note: "kiekviena naktis lyginama su eilutės 7 naktų mediana",
  wt_no_sensors: "Nė vienas gyventojas dar neturi judesio jutiklio.",
  wt_flag_restless: "Nerami",
  wt_flag_still: "Neįprastai nejudri",
  wt_flag_nodata: "Nėra duomenų",
  wt_flag_silent: "Jutiklis beveik tylus",
  rep_sensor_silent: "Jutiklis siuntė duomenis tik {pct} % šios nakties. Spragos reiškia, kad jutiklis nustojo siųsti duomenis, o ne kad gyventojas buvo nejudrus.",
  wt_legend_active: "Aktyvūs 5 min langai",
  wt_legend_still: "Ilgiausias nejudrumas (val.)",
  fap_title: "Šeimos nariai gali tvarkyti įspėjimus",
  fap_desc: "Įjungus, šeimos nariai gali patvirtinti, išspręsti, iš naujo atidaryti ir komentuoti savo gyventojų įspėjimus organizacijoje {org}.",
  note_saved: "Pastaba išsaugota",
  event_device_silent: "Jutiklis nutilo",
  event_no_movement: "Nėra judesio",
  event_no_rise: "Nėra judesio po nakties",

  dur_lt_min: "mažiau nei minutę",
  dur_min: "{m} min",
  dur_h: "{h} val.",
  dur_h_min: "{h} val. {m} min",
  am_fall: "Aptiktas kritimas",
  am_sos: "Paspaustas SOS mygtukas",
  am_low_battery: "Senka įrenginio baterija",
  am_low_battery_dev: "Senka baterija: {device}",
  am_door: "Durys atidarytos",
  am_door_in: "Durys atidarytos: {place}",
  am_door_in_detail: "Durys atidarytos: {place} ({detail})",
  am_window: "Langas atidarytas",
  am_window_in: "Langas atidarytas: {place}",
  am_window_in_detail: "Langas atidarytas: {place} ({detail})",
  am_silent: "Judesio jutiklis patalpoje {place} nesiunčia duomenų maždaug {dur} — patikrinkite maitinimą arba šliuzą",
  am_silent_nodur: "Judesio jutiklis patalpoje {place} nustojo siųsti duomenis — patikrinkite maitinimą arba šliuzą",
  am_nomove: "Patalpoje {place} judesys neaptiktas maždaug {dur}",
  am_nomove_nodur: "Patalpoje {place} judesys neaptiktas",
  am_norise: "Patalpoje {place} judesys neaptiktas nuo nakties pabaigos (paprastai atsikelia iki {time})",
  am_norise_notime: "Patalpoje {place} judesys neaptiktas nuo nakties pabaigos",
  amf_silent_res: "{name} judesio jutiklis nesiunčia duomenų nuo {time}, todėl judesys šiuo metu nestebimas.",
  amf_silent_room: "Judesio jutiklis patalpoje {place} nesiunčia duomenų nuo {time}, todėl judesys ten šiuo metu nestebimas.",
  amf_sensor_ok: "Jutiklis veikia; jis tiesiog nematė, kad kas nors judėtų.",
  amf_team: "Priežiūros komanda įspėta savo skydelyje.",
  amf_contact_device: "Jūs nurodytas kaip šio įrenginio kontaktinis asmuo.",
  amf_contact_resident: "Jūs nurodytas kaip kontaktinis asmuo: {name}.",
  al_tab_care: "Priežiūra",
  al_tab_maint: "Techninė priežiūra",
  al_maint_hint: "Nutilę jutikliai ir senkančios baterijos: techninis darbas, ne priežiūros įvykiai.",
  al_maint_empty: "Jutiklių ar baterijų problemų nėra.",
  al_auto_closed: "Uždaryta automatiškai",
  al_auto_closed_reason: "Uždaryta automatiškai — {reason}",
  al_never_seen: "niekas jo nematė prieš uždarant",
  al_resolved_by: "Išsprendė {name}",
  al_reason_movement: "judesys atsinaujino",
  al_reason_sensor: "jutiklis vėl siunčia duomenis",
  al_admin_only_ack: "Šį įspėjimą gali tvarkyti tik administratorius, nes jis nesusietas su vienu gyventoju.",
  why_title: "Kodėl tai suveikė?",
  why_since_motion: "Nuo paskutinio judesio",
  why_since_sample: "Nuo paskutinių jutiklio duomenų",
  why_threshold: "Riba",
  why_up_by: "Paprastai atsikelia iki",
  why_night: "Nakties langas",
  why_source: "Ribą nustatė",
  why_src_org: "ši organizacija",
  why_src_default: "numatytosios reikšmės",
  why_state: "Jutiklio būsena",
  why_checked: "Patikrinta",
  why_approx: "Patikros vyksta kas 5 minutes, todėl įspėjimų laikas yra apytikslis.",
  mon_label: "Judesio stebėjimas",
  mon_active: "aktyvus",
  mon_down: "nesiunčia duomenų",
  mon_down_since: "nesiunčia duomenų nuo {time}",
  admin_alerts_up_by_label: "Paprastai atsikelia iki",
  admin_alerts_up_by_question: "Jei tarp nakties pabaigos ir šio laiko judesys nematomas, sukuriamas įspėjimas „nėra judesio nuo nakties pabaigos“.",
  admin_alerts_up_by_invalid: "Turi būti vėliau nei nakties pabaiga ({end}): tai valanda, kai gyventojai paprastai jau atsikėlę, praėjus nakčiai.",
  admin_alerts_up_by_format: "Įveskite laiką formatu HH:MM.",
  admin_alerts_escalation_label: "Pranešti šeimai apie nutilusį jutiklį po",
  admin_alerts_escalation_question: "Darbuotojai nutilusį jutiklį mato iš karto. Šeimai pranešama tik tada, jei po šio laiko jis vis dar neišspręstas (iš karto, jei organizacija neturi slaugytojų).",
  admin_alerts_cooldown_note: "Uždarius įspėjimą, tas pats įspėjimas gali grįžti, kai riba vėl bus viršyta. Rytinis įspėjimas suveikia ne dažniau kaip kartą per dieną.",
  admin_alerts_stored_invalid: "Išsaugotas laikas ({up}) nėra po nakties pabaigos ({end}), todėl rytiniai įspėjimai negali veikti ir šios politikos negalima išsaugoti, kol tai nepataisyta.",
  admin_alerts_defaults_badge: "Numatytosios reikšmės",

  fap_auto_on: "Automatiškai: įjungta, nes ši organizacija neturi slaugytojų.",
  fap_auto_off: "Automatiškai: išjungta, nes ši organizacija turi slaugytojų.",
  fap_manual: "Nustatė administratorius.",
  fap_reset: "Grąžinti automatinį",
  fap_saved: "Išsaugota",
  fap_save_failed: "Nepavyko išsaugoti. Bandykite dar kartą.",
  fap_pending: "Netrukus",
  fap_retry: "Bandyti dar kartą",
  recap_title: "Rytinė nakties suvestinė",
  recap_desc_staff: "Kasdien 07:00 (organizacijos laiku) praėjusios nakties suvestinė apie kiekvieną jūsų organizacijos gyventoją.",
  recap_desc_family: "Kasdien 07:00 (organizacijos laiku) praėjusios nakties suvestinė apie jūsų artimuosius.",
  recap_on: "Įjungta",
  recap_off: "Išjungta",
  recap_email: "El. paštas",
  recap_telegram_link_first: "Prijunkite Telegram aukščiau, kad gautumėte ten.",
  recap_no_channel: "Pasirinkite bent vieną kanalą, kitaip nieko nebus išsiųsta.",
  recap_last_sent: "Paskutinį kartą išsiųsta {at}",
  recap_saved: "Nuostatos išsaugotos.",
  recap_save_failed: "Nepavyko išsaugoti nuostatų.",
  recap_unavailable: "Netrukus",
  topbar_org_label: "Organizacija",
  device_ota_phase2: "OTA diegimas taps interaktyvus 2 etape.",
  event_window_open: "Langas atidarytas",
  event_window_close: "Langas uždarytas",
  event_alarm_end: "Pavojus baigėsi",
  wt_h: "val.",
  wt_load_failed: "Nepavyko įkelti judėjimo istorijos. Bandykite vėliau.",
  recap_load_failed: "Nepavyko įkelti nuostatų — bakstelėkite, kad bandytumėte dar kartą.",
  mv_shared_note: "Šis gyventojas dalijasi kambariu. Kambario jutiklis neatskiria gyventojų, todėl judėjimas rodomas kambariui, o ne vienam asmeniui.",
  mv_shared_link: "Rodyti judėjimą: {room}",
  mv_room_shared_note: "Bendras {n} gyventojams — šio judėjimo negalima priskirti nė vienam iš jų.",
  rep_shared_room_row: "Bendras kambarys · {names}",
  admin_motion_resident: "Gyventojo lovos jutiklis",
  admin_motion_resident_hint: "Neprivaloma. Pasirinkite gyventoją tik jei jutiklis stebi jo asmeninę erdvę (pvz., nukreiptas į lovą). Tada jo judėjimo grafikai jį naudos net bendrame kambaryje.",
  admin_motion_whole_room: "Visas kambarys",
};
export default lt;
